import template from './employee_fields_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AdminEmployeeFieldsComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee_fields = ko.observableArray();
		this.categories = ko.observableArray();
		this.main_categories = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.selectedRoles = ko.observableArray();
		this.departments = ko.observableArray();
		this.department = ko.observable();		
		this.add_category = this.add_category.bind(this);
		this.add_field = this.add_field.bind(this);
		this.save_field = this.save_field.bind(this);
		this.delete_field = this.delete_field.bind(this);

		// PAGE LOAD
		this.init();
	}

	async updateData()
	{
		// Get categories
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'employee_field_category',
				limit: 1000000
			});

			if (res.status != 'ERROR')
			{
				if (res.records != null || res.records != '')
					this.categories(res.records);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load categories.'});
		}

		// Get main categories
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'employee_field_sub_category',
				limit: 1000000
			});

			if (res.status != 'ERROR')
			{
				if (res.records != null || res.records != '')
					this.main_categories(res.records);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load main categories.'});
		}

		// Get departments
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'department',
				limit: 1000000
			});

			if (res.status != 'ERROR')
			{
				if (res.records != null || res.records != '')
					res.records.unshift({ department: 'All', department_id: null });
					this.departments(res.records);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load departments.'});
		}

		// Get access roles
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'access_role',
				schema: 'grape',
				limit: 1000000,
				sortfield: 'role_name',
				sortorder: 'asc',
				filter: [{
					value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'developer', 'director'],
					operand: 'IN',
					field: 'role_name'
				}]
			});

			if (res.status != 'ERROR')
				this.access_roles(res.records);
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load access roles.'});
		}

		// Get employee fields
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_employee_field_lookup_category',
				schema: 'savanna',
				limit: 1000000
			});

			if (res.status != 'ERROR')
			{
				if (res.records != null || res.records != '' || res.records != undefined)
				{
					for (var i = 0; i < res.records.length; i++)
					{
						res.records[i].prev_field = res.records[i].field_name;

						if (!res.records[i].a_allowed_values)
							res.records[i].a_allowed_values = ko.observableArray();
						if (res.records[i].allowed_values !== null)
						{
							for (var b = 0; b < res.records[i].allowed_values.length; b++)
							{
								res.records[i].a_allowed_values.push({ name: res.records[i].allowed_values[b], });
							}
						}
					}
					this.employee_fields(res.records);
				}
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load employee fields.'});
		}

		Utils.refresh_data_visible_roles();
	};

	init()
	{
		this.updateData();
	}

	edit_field(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();

		view_row.hide();
		edit_row.show();
	};

	cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
		this.updateData();
	}

	async delete_field(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();

		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this field entry? Please note that this will delete this data from ALL employees.')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/employee_field/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted field.'), title: tr('Success') });
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	add_allowed_value(v, e)
	{
		if (v.type_indicator !== 'YesNo')
			v.a_allowed_values.push({ name: '' });
	};

	remove_allowed_value(parentIndex, itemIndex)
	{
	    if (this.employee_fields()[parentIndex].type_indicator !== 'YesNo' &&
	        this.employee_fields()[parentIndex].a_allowed_values().length > 1)
	    {
	        this.employee_fields()[parentIndex].a_allowed_values.splice(itemIndex, 1);
	    }
	};

	async move_down_order(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();

		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/admin/employee_field/move_order_down', data);
		if (res.status != 'ERROR')
			this.updateData();
	};

	async move_up_order(v, e)
	{
		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/admin/employee_field/move_order_up', data)
		if (res.status != 'ERROR')
			this.updateData();
	};

	// HELP DIALOG
	show_employee_fields_help()
	{
		Grape.dialog.open('EmployeeFieldsHelp', { employee_id: this.bindings.id });
	};

	async save_field(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();

		let data = ko.mapping.toJS(v);
		data.field_name = data.field_name.trim();

		if (data.default_value == '' || data.default_value == undefined)
			data.default_value = "Unknown";

		data.allowed_values = new Array();
		// ensure default value is part of allowed values
		data.allowed_values.push(data.default_value);
		
		for (let i = 1; i < data.a_allowed_values.length; i++)
		{
			if (data.a_allowed_values[i].name != '')
				data.allowed_values.push(data.a_allowed_values[i].name);
		}

		let valid = true;
		let message = '';
		
		if (data.view_access_roles.length == 0)
		{
			valid = false;
			message = tr('Please select roles (visible to)');
		}

		if (valid == true)
		{
			let res = await Grape.fetches.postJSON('/admin/employee_field/edit', data)
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully saved field.'), title: tr('Success') });
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});

			view_row.show();
			edit_row.hide();
		}
		else
			Grape.alerts.alert({ type: 'error', message: message, title: tr('Error') });
	};

	async add_field()
	{
		await Grape.dialog.open('EmployeeAddField', {});
		this.updateData();
	}

	async add_category(v, e)
	{
		await Grape.dialog.open('EmployeeCategoryAddPage', {});
		this.updateData();
	}
}

export default {
	name: 'employee_fields_component',
	viewModel: AdminEmployeeFieldsComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_fields_component'
};
